// @ts-strict-ignore
import { AfterViewInit, Component, forwardRef, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { LMFormComponent } from '@form/lm-form.component';
import { LMRouteComponentService } from '@services/lm-route-component.service';
import { LMModel } from '@form/model';
import { LMKeyboardShortcutService, LMKeyType } from "@app/services";

@Component({
  selector:  'lm-sub-form',     // SHOULD I PUT THE BUSY INDICATOR HERE
  standalone: false,
  template:  `
      @if (alertMessage) {
        <div class="notification alert lm-dialog-notification"> {{alertMessage}} </div>
      }
      @if (formSpec) {
        <lm-form #subform
          [formUrlInfo]="formUrlInfo"
          [formSpec]="formSpec"
          [initDataView]="dataView"
          [formOptions]="formOptions"
          [ngStyle]="{'height': '100%'}"
          (formDisplayed)="onFormDisplayed($event)"
          >
        </lm-form>
      }
      `,
  providers: [ LMRouteComponentService ]
})

export class LMSubFormDialogComponent implements OnInit, AfterViewInit {
  @Input() formUrlInfo: LMFormUrlInfo;
  @Input() formSpec: LMFormSpec;
  @Input() dataView: LMDataView;
  @Input() formOptions: LMFormOptions;
  @Input() parentModel: LMModel;
  @Input() alertMessage: string;
  @Input() defaultButton: SohoModalButton;

  @ViewChild(forwardRef(() => LMFormComponent)) formComponent; // : LMFormComponent;

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    //dont trigger default button by enter key when focused on a button, link, text area or a rich text field
    if (this.defaultButton) {
      const eventTarget: HTMLElement = event.target as HTMLElement;
      if (this.lmKeyboardShortcutService.onKeyDown(event) === LMKeyType.SAVE
          || ((event.code === 'Enter' || event.code === 'NumpadEnter')
              && eventTarget?.tagName !== 'BUTTON'
              && eventTarget?.tagName !== 'A'
              && eventTarget?.tagName !== 'TEXTAREA'
              && !eventTarget?.hasAttribute('soho-editor'))) {

        //need to trigger the blur event to trigger the field's change event
        eventTarget.blur();
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        this.defaultButton.click(null,null);
      }
    }
  }

  constructor(private lmKeyboardShortcutService: LMKeyboardShortcutService) {
    //no-op
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    // When dataview is set in the template, the form component
    // is not fully intitialized and model is null.
    // This causes empty form to come up in the required response dialog.
    // Moving set dataview to ngAfterViewInit solves this issue
    // Commenting it out as Vonny moved setData from _initDataView setter to formDataLoaded - 09/19/17

    // this.formComponent.initDataView = this.dataView;
  }

  onFormDisplayed(event) {
    setTimeout(() => {
      if (this.parentModel) {
        this.formComponent.model.applyState(this.parentModel);
      }
    }, 1);
  }

  public handleTransactionStatus(result: LMActionResult) {
    if (this.formComponent) {
      this.formComponent.handleTransactionStatus(result);
    }
  }

  public showBusyIndicator() {
    if (this.formComponent) {
      this.formComponent.showBusyIndicator();
    }

  }

  public hideBusyIndicator() {
    if (this.formComponent) {
      this.formComponent.hideBusyIndicator()
    }
  }

  public isModified(): boolean {
    return this.formComponent?.formContentComponent?.isModified();
  }
}
